import { render, staticRenderFns } from "./personnelStructure.vue?vue&type=template&id=12e4c6b6&scoped=true"
import script from "./personnelStructure.vue?vue&type=script&lang=js"
export * from "./personnelStructure.vue?vue&type=script&lang=js"
import style0 from "./personnelStructure.vue?vue&type=style&index=0&id=12e4c6b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e4c6b6",
  null
  
)

export default component.exports